import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { BACKEND_DOMAIN } from "config";

export default function SecurityScannerLogin() {
  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{ height: "100vh", display: "flex", alignItems: "center" }}
    >
      <Paper sx={{ p: 4, width: "100%" }}>
        <Typography component="h1" variant="h5" gutterBottom>
          Security scanner sign in
        </Typography>
        <Box
          component="form"
          action={`${BACKEND_DOMAIN}/auth/security-scanner/login`}
          method="post"
        >
          <TextField
            autoComplete="current-password"
            fullWidth
            label="Secret"
            margin="normal"
            name="secret"
            required
            type="password"
          />
          <Button fullWidth sx={{ mt: 3 }} type="submit" variant="contained">
            Sign in
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
